import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { projectSettingsServicedeskAutomationEditRuleRoute } from '@jira/router-routes__project-settings-service-desk-automation-routes/src/projectSettingsServicedeskAutomationEditRuleRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import ServiceDeskAutomationEditRule, {
	LazyProjectSettingsServiceDeskAutomationEditRule,
} from './ui/service-desk-automation/edit-rule/index.tsx';

export const projectSettingsServicedeskAutomationEditRuleRouteEntry: Route = createEntry(
	projectSettingsServicedeskAutomationEditRuleRoute,
	() => ({
		group: 'project-settings-servicedesk',
		layout: serviceProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		resources: [...getServiceDeskSettingsResources(), getConsolidationStateResource()],
		ufoName: 'service-management.automation.edit-rule',
		// eslint-disable-next-line no-restricted-syntax
		component: ServiceDeskAutomationEditRule,
		forPaint: [LazyAtlassianNavigation, LazyProjectSettingsServiceDeskAutomationEditRule],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
